export const REQUEST_RSVP_DATE_FETCH_EM = "REQUEST_RSVP_DATE_FETCH_EM";
export const FETCH_RSVP_DATE_EM_SUCCESS = "FETCH_RSVP_DATE_EM_SUCCESS";
export const FETCH_RSVP_DATE_EM_FAILURE = "FETCH_RSVP_DATE_EM_FAILURE";

export const CLEAR_FETCH_RSVP_DATE_EM_STATES =
  "CLEAR_FETCH_RSVP_DATE_EM_STATES";
